import { createContext, useContext } from 'react';

import type { CustomerProfileApi } from '../api';

export const CustomerProfileApiContext = createContext<CustomerProfileApi | null>(null);

export function useCustomerProfileApi() {
  const value = useContext(CustomerProfileApiContext);
  if (!value)
    throw new Error('useCustomerProfileApi must be used within CustomerProfileApiProvider.');
  return value;
}

export function useOptionalCustomerProfileApi() {
  return useContext(CustomerProfileApiContext);
}
